import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { FormControl, FormGroup, FormArray, Validators, FormBuilder } from '@angular/forms';

import { Project, School, Country, Region, User, SchoolCategory } from '../model/school.model';

import * as schoolforms from '../forms/school.management.forms';
// import { CtlFormModal } from '../../directive/ModalForm/CtlFormModal.directive';

import { CtlSchoolForm } from '../forms/school/CtlSchoolForm';
 import { CtlUserForm } from '../../../../tools/src/lib/forms/user/CtlUserForm';
 import {CtlSchoolInfoDetail } from '../../../../tools/src/lib/forms/schooldetails/CtlSchoolInfoDetail.directive';
import { ProjectmanagementService } from '../../../../projectmanagement/src/app/service/projectmanagement.service';
import { SchoolManagementService } from '../service/schoolmanagement.service';
import { UserManagementService } from '../../../../tools/src/service/user.management.service';

import { MyErrorHandler } from '../../../../tools/src/lib/errorhandler/errorhandler';
@Component({
  selector: 'app-schooladd',
  templateUrl: './schooladd.component.html',
  styleUrls: ['./schooladd.component.css']
})
export class SchooladdComponent implements OnInit {
  @ViewChild(CtlSchoolForm)
    childSchool: CtlSchoolForm;
   @ViewChild(CtlUserForm)
    childUser: CtlUserForm;

  curSchoolForm: FormGroup;
  curUserForm: FormGroup;

  project_id: string;
  projectName: string;
  school_id: string;
  clicked = false;
  countryList: any[];
  schoolCategoryList: SchoolCategory[];
  regionList: Region[];
  myrole: string;
  btnnext = false;
  country = {};
  step = 1;

  data: any;
  adminList: User[];

  step1Flag = false;

  schoolData: School;
  projectData: any;
  userData: any;
  currentSteps = 1;
  loginInfo: any;
  wizardSteps = [
    'New school details',
    'Add school admin',
    'Review & complete'
  ];

  wizardEditSteps = [
    'Edit school information',
    'Edit admin',
    'Overview & finish'
  ];

  sub;
  countryName: string;
  textDir:any;
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    // private userService: UserManagementService,
    private projectService: ProjectmanagementService,
    private schoolService: SchoolManagementService) {

      this.textDir = sessionStorage.getItem('textDir');

    }

  ngOnInit(): void {

    if (this.curSchoolForm) {
      this.curSchoolForm.reset();
    }
    if (this.curUserForm) {
      this.curUserForm.reset();
    }
    this.curSchoolForm = this.fb.group(schoolforms.formSchool);
    this.curUserForm = this.fb.group(schoolforms.formUser);
    this.loginInfo = JSON.parse(window.localStorage.getItem('loginInfoObj'));
    console.log('logininfo --' + JSON.stringify(this.loginInfo.role.name));
    
    this.getCountryList();
    this.getSchoolCategoryList();


    this.sub = this.route.params.subscribe(params => {
     // console.log('params ' + JSON.stringify(params));
      if (params.project_id) {
        this.project_id = params.project_id;
      }
      if (this.loginInfo.project && this.loginInfo.project._id) {
        this.project_id = this.loginInfo.project._id;
      }
      this.getProjectData();
    });
    // alert('sdf');
  }

  getProjectData() {
    this.projectService.detail(this.project_id).subscribe(
      (response) => {
        this.projectData = response[0];
        this.projectName = response[0].name;
        this.countryName=response[0].country.name
       console.log('projectData ' + JSON.stringify(this.projectData));
        if ( this.projectData.country) {
          this.countryList = [];
          this.countryList.push(this.projectData.country as Country);
          this.country = this.projectData.country;
          console.log('Country Name ' + JSON.stringify(this.country));
        }

        this.getRegionList(this.project_id);
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
       //   console.log('COMPLETED');
      }
    );
  }

  getRegionList(projectId) {    //
    this.schoolService.listRegion(projectId).subscribe(
      (response) => {
        this.regionList = response;
        this.regionList = [...this.regionList, {_id: 'new', name: ' - New region', description: 'add new'}];
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
        this.regionList = [];
        this.regionList = [...this.regionList, {_id: 'new', name: ' - New region', description: 'add new'}];
      },
      () => {
       // console.log('COMPLETED');
      }
    );
  }

  getSchoolCategoryList() {
    this.schoolService.listSchoolCategory().subscribe(
      (response) => {
        this.schoolCategoryList = response;
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
       // console.log('COMPLETED');
      }
    );
  }

  getCountryList() {
    if (this.project_id) {
      this.countryList.push(this.projectData.country);
    } else {
      this.projectService.listCountry().subscribe(
        (response) => {
          this.countryList = response;
        },
        (err) => {
          const errorHandlerObj = new MyErrorHandler();
          const errorHandler = errorHandlerObj.handleError(err);
          if (errorHandler.isSssionExpired) {
            this.router.navigate(['/login']);
            return true;
          }
        },
        () => {
         // console.log('COMPLETED');
        }
      );
    }
  }

  getSchoolData(school_id: string) {
    this.schoolService.detail(this.school_id).subscribe(
      (response) => {
        console.log(' School Data: ' + JSON.stringify(response));
        this.schoolData = response[0];
        console.log('schoolData ' + JSON.stringify(this.schoolData));
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
          console.log('COMPLETED');
      }
    );
  }

  formChange(flag: boolean) {
    if (this.currentSteps === 1) {
      this.btnnext = false;
      if (this.curSchoolForm.get('name').valid &&
        this.curSchoolForm.get('region').valid &&
        this.curSchoolForm.get('category').valid &&
        this.curSchoolForm.get('code').valid &&
        this.curSchoolForm.get('token').valid
      ) {
        this.btnnext = true;
        this.schoolData = this.curSchoolForm.value;
      }
    } else if (this.currentSteps === 2) {
      this.btnnext = false;
      if (this.curUserForm.get('first_name').valid &&
        this.curUserForm.get('last_name').valid &&
        this.curUserForm.get('contact.email').valid &&
        this.curUserForm.get('gender').valid) {
          this.btnnext = true;
          this.userData = this.curUserForm.value;
      }
    } else if (this.currentSteps === 3) {
      this.btnnext = true;
    }
  }

  nextStep() {
    if (this.currentSteps === 1) {
      this.childSchool.project_id = this.project_id;
      if (this.curUserForm.get('first_name').valid &&
          this.curUserForm.get('last_name').valid &&
          this.curUserForm.get('contact.email').valid) {
            this.btnnext = true;
      }else{
        this.btnnext = false;
      }
    }

    if (this.currentSteps === 2) {
      this.btnnext = false;
    }
    this.currentSteps++;

  }

  backStep() {
    this.currentSteps--;
    this.btnnext = true;
  }

  finalStep() {
    if (this.curUserForm.value) {
      const adminData = this.curUserForm.value;
      Object.keys(adminData).forEach(
        (key) => (
          adminData[key] === null ||
          adminData[key] === '' ||
          key === 'address'
        ) && delete adminData[key]);

      this.curSchoolForm.get('admin').patchValue(adminData);
    }
    this.addSchool();
  }

  cancelSchool() {
    this.curUserForm.reset();
    this.curSchoolForm.reset();
    this.router.navigate(['projectmanagement', this.project_id, 'view']);
  }

  editLink(step) {
    if (step === 'school') {
      this.currentSteps = 1;
      this.btnnext = true;
    }
    if (step === 'admin') {
      this.currentSteps = 2;
      this.btnnext = true;
    }
  }

  addSchool() {
    const data = this.curSchoolForm.value;
    if (data._id) {
      delete data._id;
    }
    if (this.project_id) {
      data.project_id = this.project_id;
      data.admin.project_id = this.project_id;
    }
    data.country = this.projectData.country;

    if (!data.project_id) {
      data.project_id = this.projectData._id;
      data.admin.project_id = this.projectData._id;
    }
    if (data.country && data.country._id) {
      data.country = data.country._id;
    }

    if (data.category && data.category._id) {
      data.category = data.category._id;
    }

    if (data.region && data.region._id) {
      data.region = data.region._id;
    }

    Object.keys(data).forEach(
      (key) => (
        data[key] === null ||
        data[key] === '' ||
        key === '_id' ||
        key === 'admins' ||
        key === 'active' ||
        key === 'code'
      ) && delete data[key]);

    this.schoolService.create(JSON.stringify(data)).subscribe(
      (response) => {
      },
      (err) => {
        console.log('ERROR: ' + err);
      },
      () => {
        window.localStorage.setItem('schoolAddSuccess', this.project_id);
        window.localStorage.setItem('schoolName', this.curSchoolForm.get('name').value);
        this.curUserForm.reset();
        this.curSchoolForm.reset();
        this.router.navigate(['projectmanagement', this.project_id, 'view']);
      }
    );
  }

}
